/**
 * Created by Administrator on 2018/1/2.
 */
import {Component, OnInit} from "@angular/core";
import {ActivatedRoute, Router} from "@angular/router";
import {Location} from "@angular/common";
import {HttpService} from "../service/http-service";
import {FileUpload} from "../service/file-upload";
import {API} from "../config/api-config";
@Component({
  templateUrl:'./shareEdit.html'
})

export class ShareEdit implements OnInit{
  constructor(
    private router:Router,
    private route:ActivatedRoute,
    private HttpService:HttpService,
    private location:Location
  ){}

  private content:string='<p></p>';


  private data:any={
    "id": 0,
    "name": "",
    "opened": "",
    "discountAmount":""
  }

  private id:number = 0;

  private isCreate:boolean=false;

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.id=params['id'];
    });

    if(this.id!=0){
      this.getData();
    }else {
      this.isCreate = true;
    }
  }

  private onReady():void{
    this.content = this.data.content;
  }

  private onChange():void{
    this.data.content = this.content;
  }

  private getData():void{
    this.HttpService.getData(API.parameter+'/'+this.id).then(res=>{
      this.data = res.data;
      this.data.opened = res.data.opened == 1 ? true : false;
    })
  }

  private submit():void{
    this.HttpService.postData(API.parameterUpdate,{
      'id':this.id,
      "name": this.data.name,
      "opened": this.data.opened?1:0,
      "discountAmount":this.data.discountAmount
    }).then(res=>{
      let data=res;
      if(data.status.code==0 || data.status.code=='0'){
        this.location.back();
      }else{
        alert(data.status.message);
      }
    });
  }

}



// WEBPACK FOOTER //
// /data/jenkins_data/workspace/NaturallyPlus_WEB_UAT/src/app/share/shareEdit.component.ts